import React, { useState, useEffect, useRef } from 'react'
import PartialCTA from './partials/cta'
import Draggable, { DraggableSlider } from '../wrappers/draggable'
import { CardButtons } from '../fragments/card-gallery'

const Milestones = ({ block }) => {
  const [active, setActive] = useState(0);
  const [milestoneWidth, setMilestoneWidth] = useState(0);
  const timelineRef = useRef(null);
  const datesRef = useRef(null)

  const toggleMilestones = e => {
    const dataIndex = e.target.getAttribute("data-index");
    const index = parseInt(dataIndex, 10);
    if (index !== active) {
      setActive(index);
      const newWidth = e.target.offsetLeft + (e.target.offsetWidth / 2);
      if (timelineRef.current) {
        // @ts-ignore
        const percentage = (newWidth / timelineRef.current.offsetWidth) * 100;
        setMilestoneWidth(percentage);
      }
    }
  };

  const slideLeft = () => {
    const newActive = active - 1 < 0 ? block.items.length - 1 : active - 1;
    setActive(newActive);
  }

  const slideRight = () => {
    const newActive = (active + 1) % block.items.length;
    setActive(newActive);
  }

  const moveDates = () => {
    if (datesRef.current && timelineRef.current) {
      // @ts-ignore
      const activeEl = datesRef.current.querySelector("li.is-active");
      if (activeEl) {
        const newWidth = Number(activeEl.offsetLeft + activeEl.offsetWidth / 2);
        // @ts-ignore
        const percentage = (newWidth / timelineRef.current.offsetWidth) * 100;
        setMilestoneWidth(percentage);
      }
    }
  }

  useEffect(() => {
    moveDates();
  }, [active]);

  const sectionState = block.block_state?.length > 0 ? `block__milestones--${block.block_state}` : '';

  return (
    <section className={`block ${block._template}  ${block.css_class_name} ${sectionState}`}>
      <div className="container" style={{ touchAction: "pan-y" }}>
        {block.type === 'buttons' && (
          <CardButtons
            slideLeft={slideRight}
            slideRight={slideLeft}
            state="large"
          />
        )}
        <Draggable
          triggerOnLeftDrag={slideRight}
          triggerOnRightDrag={slideLeft}
          active={active}
          wrapperClassName="milestones-wr"
          items={block.items}
          template={MilestonesItem}
          additionalProps={{ active, show_index: block.show_index }}
        />
        {block.type === "buttons" && (
          <section className="slider--centered slider--mt-sm">
            <DraggableSlider
              itemsCount={block.items.length}
              triggerOnClick={toggleMilestones}
              activeIndex={active}
              state={block.block_state}
            />
          </section>
        )}
        {block.type === "timeline" && <div className='timeline-wr'>
          <div ref={timelineRef} className='timeline'></div>
          <div className='timeline-active' style={{ width: `${milestoneWidth}%` }}></div>
          <ul ref={datesRef} className='dates'>
            {block.items.map((item, index) => {
              return (
                <li
                  key={index}
                  className={`${active === index ? 'is-active' : 'inactive'} ${index <= active ? 'dates--colored' : ''}`}
                  onClick={toggleMilestones}
                  data-index={index}
                >
                  {item.timeline_title}
                </li>
              )
            })}
          </ul>
        </div>}
      </div>
    </section>
  )
}

const MilestonesItem = ({ item, index, active, show_index, style }) => {
  const showCta = item.cta_field && item.cta_field.cta_url && item.cta_field.cta_url.length > 0;
  const date = new Date(item.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long' });

  return <div key={index} className={`milestone ${active === index ? 'is-active' : ''}`} style={style}>
    <div className='milestone__image'>
      {item.image && ( <img src={item.image} alt={item.image_alt_text} title={item.image_alt_text} /> )}
    </div>
    <div className='milestone__content'>
      {show_index && <h3 className="milestones-index">{index + 1 < 10 ? `0${index + 1}` : index}</h3>}
      {item.title && ( <h3 className="milestones-title" dangerouslySetInnerHTML={{__html: item.title}}></h3> )}
      {item.text && ( <div className="text-formatted" dangerouslySetInnerHTML={{__html: item.text}}></div> )}
      {(!showCta && item.date) && ( <div className='date'>{date}</div> )}
      {showCta && <PartialCTA data={item.cta_field} /> }
    </div>
  </div>
};

export default Milestones
